// src/components/common/TableSkeleton/TableSkeleton.jsx
import React from 'react';
import styles from './TableSkeleton.module.css';

const TableSkeleton = ({ columns = 3, rows = 10 }) => {
    return (
        <div className={styles.tableContainer}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        {Array(columns)
                            .fill(null)
                            .map((_, index) => (
                                <th key={`header-${index}`}>
                                    <div
                                        className={styles.skeleton}
                                        style={{ height: '20px', width: '80%' }}
                                    ></div>
                                </th>
                            ))}
                    </tr>
                </thead>
                <tbody>
                    {Array(rows)
                        .fill(null)
                        .map((_, rowIndex) => (
                            <tr key={`row-${rowIndex}`}>
                                {Array(columns)
                                    .fill(null)
                                    .map((_, colIndex) => (
                                        <td key={`cell-${rowIndex}-${colIndex}`}>
                                            <div
                                                className={styles.skeleton}
                                                style={{
                                                    height: '20px',
                                                    width: colIndex === 0 ? '60%' : '80%',
                                                }}
                                            ></div>
                                        </td>
                                    ))}
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableSkeleton;